module.exports = __webpack_public_path__ + "img/路线图页-地图D.54b431b2.png";